/*
  Generic GSAP ScrollTrigger fromTo-stagger reveal, shared by every homepage
  section that just does `gsap.fromTo(selector, {opacity:0,axis:distance}, {opacity:1,axis:0,stagger,scrollTrigger})`
  in the Cloudflare build (NewArrivalsSection, FeaturesSection, ComparisonSection,
  SpecComparisonSection all use this exact pattern with different selectors/axes).

  Usage: add to the section root:
    data-reveal-stagger=".my-item-class"
    data-reveal-axis="y" | "x"          (default: y)
    data-reveal-distance="40"           (default: 40)
    data-reveal-interval="0.12"         (default: 0.12, gsap `stagger`)
    data-reveal-start="top 80%"         (default: top 80%)
*/
(function () {
  function init(root) {
    if (typeof window.gsap === 'undefined') return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    var selector = root.getAttribute('data-reveal-stagger');
    var axis = root.getAttribute('data-reveal-axis') || 'y';
    var distance = parseFloat(root.getAttribute('data-reveal-distance') || '40');
    var stagger = parseFloat(root.getAttribute('data-reveal-interval') || '0.12');
    var start = root.getAttribute('data-reveal-start') || 'top 80%';
    var targets = root.querySelectorAll(selector);
    if (!targets.length) return;

    if (root.hasAttribute('data-reveal-each')) {
      // Each element gets its own ScrollTrigger (matches the Cloudflare build's
      // gsap.utils.toArray().forEach pattern) — used where items are spread
      // across a long page (Manifesto pillars, About timeline), rather than
      // all firing together off one shared trigger.
      targets.forEach(function (el) {
        var fromVars = { opacity: 0 };
        fromVars[axis] = distance;
        var toVars = {
          opacity: 1,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: start },
        };
        toVars[axis] = 0;
        gsap.fromTo(el, fromVars, toVars);
      });
      return;
    }

    var fromVars = { opacity: 0 };
    fromVars[axis] = distance;
    var toVars = {
      opacity: 1,
      duration: 0.9,
      stagger: stagger,
      ease: 'power3.out',
      scrollTrigger: { trigger: root, start: start },
    };
    toVars[axis] = 0;

    gsap.fromTo(targets, fromVars, toVars);
  }

  function boot() {
    document.querySelectorAll('[data-reveal-stagger]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
